import {Button} from 'antd';
import React, {FunctionComponent, useContext} from 'react';
import {useDispatch} from 'react-redux';

import {DynamicIcon} from 'components/dynamic-icon';
import {selectTableEntityMetadata, setMetadata} from 'entities/metadata';
import {createLoadTableData} from 'modules/data/data-actions';
import {selectFilterEntityData} from 'modules/data/data-selectors';
import {EEntityType} from 'shared/constants/entities';
import {useAppSelector} from 'store/config/hooks';

import {ETableMode, TableModeContext} from '../../context';
import {disabledFields} from '../button-action-edit-field/button-action-edit-fields';
import {ITableActionProps} from '../table-action-types';

export const ButtonCancelChanges: FunctionComponent<ITableActionProps> = ({
    meta,
    entityName,
    ...props
}: ITableActionProps) => {
    const dispatch = useDispatch();
    const {setTableMode} = useContext(TableModeContext);
    const filterData = useAppSelector(selectFilterEntityData(entityName))?.data;
    const metadata = useAppSelector(selectTableEntityMetadata(entityName));

    const {actionTitle} = meta;
    const tableDataOptions = {
        useContext: !!metadata?.useContext,
        useSearch: !!metadata?.isSearchable,
        disabledPagination: metadata?.disabledPagination,
    };

    const handleClick = () => {
        setTableMode(ETableMode.VIEW);
        const newMetaData = disabledFields(metadata, true);

        dispatch(setMetadata({
            entityName,
            entityType: EEntityType.TABLE,
            metadata: newMetaData,
        }));

        dispatch(createLoadTableData(EEntityType.TABLE)(
            entityName,
            {...tableDataOptions, paramsToBeConverted: filterData},
            entityName,
            meta?.referenceUrl,
        ));
    };

    return (
        <Button
            {...props}
            type="default"
            onClick={handleClick}
            style={{width: 'min-content'}}
        >
            {meta?.actionIcon && ((
                <div className="action-icon">
                    <DynamicIcon
                        type={meta.actionIcon}
                        style={{fontSize: 16}}
                    />
                </div>
            ))}
            {actionTitle}
        </Button>
    );
};
